export function Skeleton({ className = '' }) {
  return <div className={`animate-pulse rounded-lg bg-border/60 ${className}`} />;
}

export function SkeletonCard() {
  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-3">
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-8 w-1/2" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
}
